import {
  GetSelfSchedulingState,
  GetSelfSchedulingStateVariables,
} from 'types/graphql'

import { useParams } from '@cedarjs/router'
import { TypedDocumentNode, useQuery } from '@cedarjs/web'

const QUERY: TypedDocumentNode<
  GetSelfSchedulingState,
  GetSelfSchedulingStateVariables
> = gql`
  query GetSelfSchedulingState($schedulingCaseNotificationId: String!) {
    selfSchedulingState(
      schedulingCaseNotificationId: $schedulingCaseNotificationId
    ) {
      id
      schedulingCase {
        id
        patientMessage
        firstAvailableTargetDate
        lastAvailableTargetDate
        locationType
        visitPractitionerType
        appointmentDefinitions {
          id
          type
        }
        targetDate {
          id
          date
          dateEnd
          value
          valueEnd
          unit
          unitEnd
          prefix
          rangeType
        }
        location {
          id
          timezone
          description
          name
          phoneNumber
          logoUrl
          address {
            id
            line1
            line2
            city
            postalCode
            state
            country
            updatedAt
          }
          tenantId
        }
        patient {
          id
          namePrefix
          givenName
          middleName
          familyName
          nameSuffix
          birthDate
        }

        newAppointment {
          id
          start
          practitioner {
            id
            namePrefix
            givenName
            middleName
            familyName
            nameSuffix
          }
          location {
            id
            timezone
            description
            name
            phoneNumber
            address {
              id
              line1
              line2
              city
              postalCode
              state
              country
              updatedAt
            }
          }
        }
        resolvedStatus
      }
    }
  }
`

export function useSelfSchedulingState() {
  const { notificationId } = useParams()

  return useQuery<GetSelfSchedulingState>(QUERY, {
    variables: { schedulingCaseNotificationId: notificationId },
  })
}
